import { useMediaQuery } from '@chakra-ui/react';

import { MediaQueriesEnum } from '@/enums/mediaQueries.enum';
import { StorageKeysEnum } from '@/enums/storageKeys.enum';

import { useLocalStorage } from './useLocalStorage';

export const useSettings = () => {
  const [isMobile, isTablet, isDesktop] = useMediaQuery(
    [
      MediaQueriesEnum.isMobile,
      MediaQueriesEnum.isTablet,
      MediaQueriesEnum.isDesktop,
    ],
    { ssr: false },
  );
  const { value: lang, setItem: setLang } = useLocalStorage<string>(
    StorageKeysEnum.i18nextLng,
  );

  return { isMobile, isTablet, isDesktop, lang, setLang };
};
